







































import { openLinkInNewTab } from '@/router'
import CookieSettingsDialog from '@/modules/authentication/components/cookie-settings/CookieSettingsDialog.vue'

export default {
  components: {
    CookieSettingsDialog
  },
  methods: {
    goToTermAndConditions() {
      openLinkInNewTab('https://www.sennder.com/terms-conditions')
    },
    goToParticipationAndUse() {
      openLinkInNewTab('https://www.sennder.com/orcas/terms-conditions')
    },
    goToPrivacyPolicy() {
      openLinkInNewTab('https://www.sennder.com/orcas/privacy-policy')
    },
    openCookieSettingsDialog() {
      this.$refs.cookieSettingsDialog.open()
    }
  }
}
